const ICON_HEATMAP = ({ color = "#000", strokeWidth = 3, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    fill="none"
    {...props}
  >
    <path
      className="path_svg"
      stroke={color}
      strokeWidth={strokeWidth}
      d="M11.764 16.369c3.147-4.04 6.624-10.449 11.718-9.933 4.66.472 4.944 8.225 8.682 11.047 3.082 2.327 5.985 1.125 8.614 3.955 3.253 3.501 3.537 9.666-.033 13.018-2.517 2.364-4.787.619-7.65 2.547-2.029 1.365-1.916 4.649-4.152 5.64-5.21 2.31-12.26-.103-16.7-3.677-3.475-2.796-5.66-7.69-5.606-12.15.046-3.878 2.74-7.387 5.125-10.447Z"
    />
    <path
      className="path_svg"
      stroke={color}
      strokeWidth={strokeWidth}
      d="M16.344 20.068c1.803-2.197 3.636-5.752 6.47-5.552 3.054.215 3.78 5.325 6.207 7.19 2.367 1.82 5.493 1.635 7.589 3.762 1.328 1.35 1.207 2.773.19 3.912-1.567 1.753-4.9 1.175-6.906 2.402-1.641 1.003-2.926 4.418-4.766 4.978-3.363 1.023-6.574-.475-9.257-2.746-2.032-1.72-3.395-4.625-3.275-7.285.115-2.545 2.133-4.69 3.749-6.66z"
    />
    <path
      className="path_svg"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M22.17 30.306a3.415 3.415 0 1 0 0-6.83 3.415 3.415 0 0 0 0 6.83z"
    />
  </svg>
);

export default ICON_HEATMAP;
